import React from 'react'
import { IconButton, Tooltip } from '@mui/material'
import PeopleAltIcon from '@mui/icons-material/PeopleAlt'
import { scraperSiteSelected } from 'Pages/Admin/GlobalExecution/@signals'

export default function actionsColumn() {
	return {
		name: 'idSite',
		label: ' ',
		options: {
			filter: false,
			sort: false,
			customBodyRowRender: (idSite, { name }) => (
				<Tooltip title="View searches per user">
					<IconButton
						size="small"
						onClick={() => { scraperSiteSelected.value = { idSite, name } }}
					>
						<PeopleAltIcon fontSize="small" />
					</IconButton>
				</Tooltip>
			),
		},
	}
}